"use client";

import { ChevronDown } from "lucide-react";
import NextLink from "next/link";
import { useSession } from "next-auth/react";
import React from "react";
import { Button } from "~/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "~/components/ui/dropdown-menu";
import { cn } from "~/lib/utils";
import type { ResolvedNavSection } from "./nav-resolver";

type Props = {
  adminSection: ResolvedNavSection;
};

export function AdminNavMenu({ adminSection }: Props) {
  const { data: session } = useSession();

  if (session?.user.role !== "ADMIN") {
    return null;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="link"
          className="text-muted-foreground dark:text-foreground hover:no-underline transition-colors hover:text-foreground"
        >
          <span>{adminSection.label}</span>
          <ChevronDown className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {adminSection.children.map((child, index) => {
          const prevChild = adminSection.children[index - 1];
          const isGroupBoundary =
            prevChild && child.group && prevChild.group !== child.group;

          return (
            <React.Fragment key={child.labelKey}>
              {isGroupBoundary && <DropdownMenuSeparator />}
              <DropdownMenuItem asChild>
                <NextLink
                  href={child.href}
                  prefetch={child.labelKey === "Logga ut" ? false : undefined}
                  className={cn(
                    "cursor-pointer w-full flex items-center",
                    child.variant === "ghost" && "text-destructive font-medium",
                  )}
                >
                  {child.label}
                </NextLink>
              </DropdownMenuItem>
            </React.Fragment>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
